module.exports = __webpack_public_path__ + "images/ExternalPromo/guitartricks_square_3.gif?03211";